import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useGatewaysListFilterFields } from './hooks/useGatewaysListFilterFields';

export const GatewaysListFilterForm: React.FC = () => {
  const fields = useGatewaysListFilterFields();

  return <FilterFields fields={fields} />;
};
